module.exports = __webpack_public_path__ + "img/belgium-infectious-diseases-male.1a8b2c60.png";